import React, { useState } from "react";

import ShipeeziNewGrid, { GeneralActions } from "Components/AppGrid/shipeezi-new-grid";
import { Fleet } from "Models/fleet";
import { Filters, Searches } from "Models/shipeezi.table";
import { useTranslation } from "react-i18next";
import { getMeasurement } from "Util/getMeasurement";

import { getOrdersTableColumns } from "../../../../Subcontractors/EditSubcontractor/Orders/getOrdersTableColumns";
import useEquipmentActions from "../../../hooks/useEquipmentActions";

interface OrdersSectionProps {
  fleet: Fleet;
}

export const OrdersSection = (props: OrdersSectionProps) => {
  const { fleet } = props;
  const { t: translate } = useTranslation();
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [filters, setFilters] = useState<Filters>();
  const [searches, setSearches] = useState<Searches>([]);
  const { getFleetOrdersWithCount, getJobStatuses, getJobTypes } = useEquipmentActions();
  const [disableCustomerSorting, setDisableCustomerSorting] = useState<boolean>(false);
  const [disableOriginSorting, setDisableOriginSorting] = useState<boolean>(false);
  const [disableDestinationSorting, setDisableDestinationSorting] = useState<boolean>(false);
  const [sorting, setSorting] = useState<Array<string[]>>();
  const measurement = getMeasurement();

  const {
    data: { rows: orders, count: ordersTotal },
    isFetching,
  } = getFleetOrdersWithCount({
    page,
    pageSize,
    filters,
    searches,
    sorting,
    equipmentId: fleet.id,
  });

  const { data: jobStatuses } = getJobStatuses();
  const { data: jobTypes } = getJobTypes();

  const handleSearch = (values: Searches) => {
    setSearches(values);
    setPage(0);
  };

  const handleFilter = (value: Filters) => {
    const filtersKeys = Object.getOwnPropertyNames(value);

    setFilters(filtersKeys?.length ? value : undefined);
  };

  const columns = getOrdersTableColumns({
    translate,
    disableCustomerSorting,
    disableDestinationSorting,
    disableOriginSorting,
    measurement,
    setDisableCustomerSorting,
    setDisableDestinationSorting,
    setDisableOriginSorting,
    setSorting,
  });

  const generalActions: GeneralActions = {
    orderBy: { left: ["handleSearch", "handleFilterBy"] },
    handleSearch: {
      onSearch: (filters) => handleSearch(filters),
    },
    handleFilterBy: {
      onChange: handleFilter,
      categories: [
        {
          name: translate("type"),
          options: jobTypes.map((jobType) => jobType?.name || ""),
        },
        {
          name: translate("status"),
          options: jobStatuses.map((jobStatus) => jobStatus?.name || ""),
        },
      ],
    },
  };

  return (
    <ShipeeziNewGrid
      data={orders}
      totalItems={Number(ordersTotal)}
      columns={columns}
      showSelection={false}
      showSort={false}
      currentPage={page}
      pageSize={pageSize}
      loadingData={isFetching}
      pageSizeList={[10, 20, 40, 60]}
      onChangePageSize={setPageSize}
      onNextPage={setPage}
      onPreviousPage={setPage}
      onGoToPage={setPage}
      positionActionsColumn="right"
      generalActions={generalActions}
      keyExtractor={(data) => data?.id?.toString()}
      emptyData={translate("noInformationToBeShown")}
    />
  );
};
